<template>
  <div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="selectChange" style="width:100%" :height="tableHeight" >
        <el-table-column label="序号" width="66" align="center">
          <template slot-scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
        </el-table-column>
        <el-table-column prop="companyName" label="机构名称" align="left">
          <template slot-scope="scope"><span>{{scope.row.companyName }}</span><span class="nizeng" v-if="scope.row.companyFlag != 1">拟增</span></template>
        </el-table-column>
        <el-table-column prop="companyCategoryName" label="机构类别" align="left"> </el-table-column>
        <el-table-column prop="companyLevel" label="机构级别" align="left">
            <template slot-scope="scope">
                <span class="level">{{companyLevel[scope.row.companyLevel]}}</span><!-- <span :class="'level_'+scope.row.companyLevel"></span> -->
            </template>
        </el-table-column>
        <el-table-column prop="companyDetailAddress" label="机构地址" align="left"> </el-table-column>
        <el-table-column prop="xzqh" label="行政区划" align="left">
          <template slot-scope="scope"><span>{{scope.row.areaName}}</span></template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间" align="left" width="120">
          <template slot-scope="scope"><span>{{scope.row.createTime.substring(0,10)}} </span></template>
        </el-table-column>
        <el-table-column width="120" label="操作" align="left">
          <template slot-scope="scope">
            <el-button @click="detailClick(scope.row.id)" type="primary" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" >
      </el-pagination>
      <div style="clear: both"></div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
              selectIdArray:[],
              pageSize:10,
              currentPage:1,
              total:0,
              tableData: [],
              tableHeight: null,
              dataUrl: '/api/siteselection/company/getCompanyBySearchParams',
              companyLevel: {
                0: '一级',
                1: '二级',
                2: '三级',
                3: '无级别',
                4: '未定级'
              },
            }
        },
        props:["serchParam"],
        mounted(){
          var search = document.getElementsByClassName('searchBox')[0].clientHeight;
          var pagination = document.getElementsByClassName('el-pagination')[0].clientHeight;
          this.tableHeight = this.viewportToPixels('100vh')-search-pagination-75
          this.fillTableData(1);
        },
        methods:{
          viewportToPixels(value) {
            var parts = value.match(/([0-9.]+)(vh|vw)/)
            var q = Number(parts[1])
            var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
            return side * (q/100)
          },
          detailClick(id){
            this.$emit("detail", id)
          },
          fillTableData(pageResetFlag){
            if(pageResetFlag==undefined){
              this.currentPage=1;
            }
            let param= {};
            if(this.serchParam != null){
              param=this.serchParam;
            }
            param["pageNum"]=this.currentPage;
            param["pageSize"]=this.pageSize;
            param["regionId"]=this.serchParam.regionId ? this.serchParam.regionId : this.$store.state.userInfo.user.region;
            this.axios.post(this.dataUrl,param).then( res =>{
                let page = res.data.model;
                this.total=page.total;
                this.currentPage=page.pageNum;
                this.tableData=page.list;
             });
          },
          handleSizeChange(size){
            this.pageSize=size;
            this.fillTableData(1);
          },
          handleCurrentChange(pageNum){
             this.currentPage=pageNum;
             this.fillTableData(1);
          },
          prevClick(pageNum){
            this.currentPage=pageNum;
            this.fillTableData(1);
          },
          nextClick(pageNum){
            this.currentPage=pageNum;
            this.fillTableData(1);
          },
          selectChange(selection){
            this.selectIdArray=[];
            for(let i = 0; i < selection.length; i ++){
              this.selectIdArray[i]=selection[i].id;
            }
          },
          getSelectId(){
            return this.selectIdArray;
          }
        }
    }
</script>

<style scoped lang="less">
/deep/.el-table{
  overflow: auto;
}
/deep/.el-table::-webkit-scrollbar{
 display: none;
}
/deep/.el-table::before{
  height: 0;
}
/deep/.el-pagination{
    background: white;
    height: 45px;
    line-height: 45px;
    padding: 10px 20px 0 0;
    text-align: right;
}
.level{
  span{
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
.nizeng{
  display: inline-block;
  padding: 0px 6px;
  background: #b6d6f7;
  border-radius: 4px;
  color: #047dfb;
  font-size: 12px;
  font-weight: bold;
  margin-left: 8px;
}
.level_0{ background: #CC0000; }
.level_1{ background: #E58749; }
.level_2{ background: #FFB726; }
.level_3{ background: #666666; }
.level_4{ background: #E6E6E6; }
</style>